import { LocationSearchResult } from "../../../data/mazemap.api";
import { SearchSource } from "../MapSearch";
import { useMapSearch } from "../../../data/mazemap.api";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useCallback } from "react";

export const useLocationSource = (
  query: string
): SearchSource<LocationSearchResult> => ({
  title: "Locations",
  source: useMapSearch(query),
  transformer: useCallback((searchResult) => {
    const id = () => {
      if (
        searchResult.type === "category" ||
        searchResult.type === "building"
      ) {
        return searchResult.id;
      } else if (searchResult.type === "poi") {
        return searchResult.poiId;
      }
    };

    const otherName = () => {
      if (searchResult.type === "building") {
        return searchResult.dispBldNames.slice(1).join(", ");
      } else if (searchResult.type === "poi") {
        return searchResult.dispPoiNames.slice(1).join(", ");
      }
    };

    const emToStrong = (text?: string) => {
      return text?.replace(/<(\/?)em>/g, "<$1strong>") ?? "";
    };

    return {
      icon: FaMapMarkerAlt,
      iconColour: "lancsRed.500",
      title: emToStrong(searchResult.title),
      subtitle:
        searchResult.type === "poi" && searchResult.dispBldNames.length > 0
          ? emToStrong(searchResult.dispBldNames[0])
          : "",
      description: otherName() ? `(${emToStrong(otherName())})` : "",
      tag:
        searchResult.type === "building"
          ? "Building"
          : searchResult.type === "category"
          ? "Category"
          : searchResult.type === "poi"
          ? "Room"
          : "",
      to: `/location/${searchResult.type}/${id()}`,
    };
  }, []),
  priority: -1,
});
